import { render, staticRenderFns } from "./DocumentsList.vue?vue&type=template&id=639b409e&scoped=true&"
import script from "./DocumentsList.vue?vue&type=script&lang=ts&"
export * from "./DocumentsList.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentsList.vue?vue&type=style&index=0&id=639b409e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639b409e",
  null
  
)

export default component.exports